import IAlert from "@/models/modelView/IAlert";
import { PointerUtil } from "@/utils/pointer.util";
import { Feature } from "ol";
import { Point } from "ol/geom";
import { fromLonLat } from "ol/proj";
import Icon from "ol/style/Icon";
import Style from "ol/style/Style";
import BaseFeature from "./base.feature";

export default class AlertFeature extends BaseFeature {

    alert: IAlert;

    constructor(alert: IAlert) {
        super()
        this.alert = alert
    }

    getFeature() {
        return new Feature({
            geometry: new Point(fromLonLat([this.alert.longitude || 0, this.alert.latitude || 0])), //recoge las coordenadas de ubicacion
            type: 'alert',
            alert: this.alert
        })
    }

    getStyle(): Style {
        return new Style({
            image: new Icon(({
                anchor: [0.5, 1],
                scale: 0.45,
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                crossOrigin: 'anonymous',
                src: PointerUtil.getPointerPath(this.alert.type)
            }))
        })
    }

    isValid(): boolean {
        return true
    }
}